if (!customElements.get('slider-component')) {
  class SliderComponent extends HTMLElement {
    constructor() {
      super();
      this.slider = this.querySelector('[id^="Slider-"]');
      this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
      this.prevButton = this.querySelector('button[name="previous"]');
      this.nextButton = this.querySelector('button[name="next"]');
      this.currentPageElement = this.querySelector('.slider-counter--current');
      this.pageTotalElement = this.querySelector('.slider-counter--total');
      this.currentPage = 1;

      if (!this.slider || !this.nextButton) return;

      this.initPages();
      this.slider.addEventListener('scroll', this.update.bind(this));
      this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
      this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
    }

    initPages() {
      this.sliderItemsToShow = Array.from(this.sliderItems).filter((el) => el.clientWidth > 0);
      if (this.sliderItemsToShow.length < 2) return;
      this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
      this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
      this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
      this.update();
    }

    update() {
      if (!this.slider || !this.nextButton) return;
      this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;
      if (this.currentPageElement) this.currentPageElement.textContent = this.currentPage;
      if (this.pageTotalElement) this.pageTotalElement.textContent = this.totalPages;
      this.prevButton.disabled = this.currentPage === 1;
      this.nextButton.disabled = this.currentPage === this.totalPages;
    }

    onButtonClick(event) {
      event.preventDefault();
      const step = event.currentTarget.name === 'next' ? 1 : -1;
      const nextIndex = this.currentPage - 1 + step;
      if (this.sliderItemsToShow[nextIndex]) {
        this.slider.scrollTo({ left: this.sliderItemsToShow[nextIndex].offsetLeft, behavior: 'smooth' });
      }
    }
  }
  customElements.define('slider-component', SliderComponent);
}
